/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import React, { FC, useEffect, useState } from 'react';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import { StorageHelper } from '../../utils/StorageHelper';
import { ValesData } from '../../types/Types';
import CondLegalesModal from './condLegalesModal';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';
import DownloadAppPopup from '../../components/DownloadAppPopup';
import BodyTop from './BodyTop';
import ValesCoreBody from './ValesCoreBody';
import NoVales from './NoVales';
import { useValeContext } from './context/Vale.context';
import { FiltersConstants } from '../../utils/FiltersConstants';

interface Props {
  isApp: boolean;
  hayVales: boolean;
  view: boolean;
  valesNoAct: ValesData[];
  retrieveValesAhorro: any;
  isMobile: boolean;
  handleVerMasClick: any;
  valesAct: ValesData[];
  valesPreAct: ValesData[];
  valesCanj: ValesData[];
  existVales: boolean;
  urlMDScrollPreferencia: string;
  filtrosVisiblesProductos: string[];
  filtrosVisiblesOtros: string[];
  isFiltrosSoportePostalVisible: boolean;
  filtrosOtros: string[];
  filtrosProductos: string[];
}

function mostrarValesHtml(lsValesVisibles: ValesData[]) {
  if (lsValesVisibles.length !== 0 && lsValesVisibles[0] != null) {
    lsValesVisibles.map((vale) => {
      const cuponHtml = document.querySelector(`[data-id='${vale.valeEAN}']`);
      cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_OCULTOS);
      cuponHtml?.classList.add(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      return true;
    });
  }
}

const ValesEroski: FC<Props> = (props) => {
  const {
    isApp,
    hayVales,
    view,
    urlMDScrollPreferencia,
    filtrosVisiblesProductos,
    filtrosVisiblesOtros,
    isFiltrosSoportePostalVisible,
    filtrosOtros,
    filtrosProductos,
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [promocion, setPromocion] = useState<boolean>(false);

  const {
    loadFilterProducs,
    loadFilterOtros,
    loadFiltrosOtrosAMostrar,
    loadIsFiltrosSoportePostalVisible,
  } = useValeContext();
  const setStyle = () => {
    const isEcommerceBot = StorageHelper.isEcommerceBot();
    StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);
  };
  useEffect(() => {
    loadFilterProducs(filtrosProductos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosProductos]);
  useEffect(() => {
    loadFilterOtros(filtrosOtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosOtros]);
  useEffect(() => {
    loadFiltrosOtrosAMostrar(filtrosVisiblesOtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosVisiblesOtros]);
  useEffect(() => {
    loadIsFiltrosSoportePostalVisible(isFiltrosSoportePostalVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFiltrosSoportePostalVisible]);
  const {
    activeFilters,
    filtrosOtrosActivos,
    valesVisiblesSFNoActivados,
    voucherNotActWithFilterApplied,
    valesVisiblesSFActivados,
    voucherActWithFilterApplied,
    valesVisiblesSFCanjeados,
    voucherCanjWithFilterApplied,
    valesVisiblesSFPromos,
    voucherPromoWithFilterApplied,
  } = useValeContext();

  useEffect(() => {
    if (activeFilters.length > 0 || filtrosOtrosActivos.length > 0) {
      mostrarValesHtml(voucherNotActWithFilterApplied);
      mostrarValesHtml(voucherActWithFilterApplied);
      mostrarValesHtml(voucherCanjWithFilterApplied);
      mostrarValesHtml(voucherPromoWithFilterApplied);
    } else {
      mostrarValesHtml(valesVisiblesSFNoActivados);
      mostrarValesHtml(valesVisiblesSFActivados);
      mostrarValesHtml(valesVisiblesSFCanjeados);
      mostrarValesHtml(valesVisiblesSFPromos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeFilters,
    filtrosOtrosActivos,
    voucherNotActWithFilterApplied,
    voucherActWithFilterApplied,
    voucherCanjWithFilterApplied,
    voucherPromoWithFilterApplied,
  ]);
  return (
    <>
      <BotonVolverFlotante />
      {setStyle}
      <BodyTop
        view={view}
        urlMDScrollPreferencia={urlMDScrollPreferencia}
        filtrosVisiblesProductos={filtrosVisiblesProductos}
        filtrosVisiblesOtros={filtrosVisiblesOtros}
      />
      <>
        <section className="o-section--large misValesPage" id="seccion-vales">
          <div className="container">
            {hayVales && (
              <ValesCoreBody
                {...props}
                setVisible={setVisible}
                setPromocion={setPromocion}
              />
            )}
            {!hayVales && <NoVales />}
          </div>
        </section>
      </>
      <CondLegalesModal
        promocion={promocion}
        setPromocion={setPromocion}
        visible={visible}
        setVisible={setVisible}
      />
      <DownloadAppPopup page="vales" />
    </>
  );
};

export default ValesEroski;
